var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-gap-1"},[(_vm.label)?_c('label',{class:[
      'tw-text-xs tw-font-poppins',
      'tw-text-[#1F2229]',
    ]},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({class:[
      'tw-w-full tw-px-3 tw-py-2',
      'tw-bg-[#EEEFF2] tw-text-[#1F2229]',
      'tw-rounded-md tw-border-none',
      'tw-font-poppins',
    ],on:{"input":_vm.handleUpdate}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }